import React from "react";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";
import CorporateSidebar from "../components/Corporate/CorporateSidebar";

const CorporateValues = () => {
  return (
    <div>
      <HeroSlider />
      <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        {/* <div className="text-sm text-gray-600 mb-4">
          <span className="underline">ana sayfa</span> &nbsp;>&nbsp;
          <span className="underline">kurumsal</span> &nbsp;>&nbsp;
          <span>değerlerimiz</span>
        </div> */}

        <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

        <div className="flex flex-col md:flex-row gap-10">
          <CorporateSidebar />
          <div className="flex-1">
            <h2 className="text-2xl font-bold mb-4 text-[#003132]">Değerlerimiz</h2>
            <p className="text-gray-800 leading-relaxed">
             Abone Halı Yıkama olarak, kurumsal kimliğimizin temelinde güvenilirlik, sürdürülebilirlik ve müşteri memnuniyeti yatmaktadır.  
              Bizim için her iş, kalite ve etik değerler çerçevesinde yürütülmelidir.
            </p>

            <p className="text-gray-800 leading-relaxed mt-4">
              Çalışanlarımızın profesyonelliği ve sürekli gelişimi, sunduğumuz hizmetin kalitesini şekillendirmektedir.  
              Topluma ve çevreye duyarlı bir anlayışla hareket ederek, güven ve sadakat ilişkisi kurmayı amaçlıyoruz.
            </p>

            {/* Değerler listesi */}
            <div className="mt-6 p-4 bg-gray-100 rounded">
              <h3 className="text-xl font-semibold text-[#003132]">Temel Değerlerimiz</h3>
              <ul className="list-disc pl-5 text-gray-700 mt-2">
                <li>Güvenilirlik ve şeffaflık</li>
                <li>Kalite ve müşteri memnuniyeti</li>
                <li>Sürdürülebilirlik ve çevre bilinci</li>
                <li>Çalışan gelişimi ve profesyonellik</li>
                <li>Toplum ve etik değerler</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CorporateValues;
